import React, { useState, useEffect } from "react";
import group from "../../assets/svg/exampage/group.svg";
import live from "../../assets/svg/exampage/live.gif";
import { useSelector } from "react-redux";
import { getSelectedEventsDetails, getToken, getUserInfo } from "../../store/auth/selectors";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { CONFIG_VARS } from "../../constants/configuration";
import { ExamConfigHelper } from "../../constants/examConfig";
import useLeadCapture from "../UseLeadCapture";
import { ROUTES } from "../../constants/routes";
import { useAnalytics } from "../../contexts/AnalyticsContext";

export const ExamPageAtempt = ({ status }) => {
  const examdetailes = useSelector(getSelectedEventsDetails);
  const user = useSelector(getUserInfo);
  const history = useHistory();
  const access_token = useSelector(getToken);
  const { handelTakeTestLSQ } = useLeadCapture();
  const analytics = useAnalytics();
  const [isUpdating, setIsUpdating] = useState(false);
  const [buttonConfig, setButtonConfig] = useState({
    text: "Attempt Now",
    action: "takeTest",
    showLive: true
  });

  const getLandingSource = () => {
    const storedTimestamp = sessionStorage.getItem("landing_timestamp");
    const storedSource = sessionStorage.getItem("landing_source");

    if (storedTimestamp) {
      const timestamp = parseInt(storedTimestamp, 10);
      const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000;

      if (isExpired) {
        return "organic";
      }
    }

    return storedSource || "organic";
  };

  const currentExam = examdetailes.title.toLowerCase();

  const getImage = (examName) => ExamConfigHelper.getExamImage(examName);
  const getClass = (examName) => ExamConfigHelper.getExamCssClass(examName);

  useEffect(() => {
    const determineButtonConfig = () => {
      const examStatus = examdetailes?.is_exam_status;

      if (examStatus === "COMPLETED") {
        return {
          text: "View Report",
          action: "viewReport",
          showLive: false
        };
      }

      if (examStatus === "NOT_STARTED") {
        return {
          text: "Attempt Now",
          action: "takeTest",
          showLive: true
        };
      }

      if (examStatus === "STARTED" || examStatus === "INITIATED") {
        if (examdetailes?.can_resume_exam === true) {
          return {
            text: "Resume Test",
            action: "takeTest",
            showLive: true
          };
        } else {
          return {
            text: "View Report",
            action: "viewReport",
            showLive: false
          };
        }
      }

      return {
        text: "Attempt Now",
        action: "takeTest",
        showLive: true
      };
    };

    setButtonConfig(determineButtonConfig());
  }, [examdetailes]);

  const handleViewReport = () => {
    if (currentExam === "career counselling") {
      history.push(ROUTES.CAREER_COUNSELINGP_REPORTS);
    } else {
      history.push(`/reports/${examdetailes.exam_id}`);
    }
  };

  const handleViewOldReport = () => {
    const source = getLandingSource();
    const baseUrl = `${CONFIG_VARS.scoreViewreportUrl}/inmobious`;
    const crn_id = user.crn_id;
    const token = access_token.replace("Bearer ", "");
    const url = `${baseUrl}?token=${token}&crn_id=${crn_id}&is_from=genius&landing_source=${source}`;
    window.open(url, "_self", "noreferrer");
  };

  const redirectToEvent = async () => {
    const testId = examdetailes.exam_id;
    const source = getLandingSource();

    if (buttonConfig.action === "takeTest") {
      analytics.trackAttemptNowClicked(testId, source);
    }

    if (currentExam === "career counselling") {
      history.push("/career-page");
      return;
    }

    if (buttonConfig.action === "viewReport") {
      if (examdetailes?.event_provider === "SCORE") {
        handleViewOldReport();
      } else {
        handleViewReport();
      }
      return;
    }

    setIsUpdating(true);
    try {
      await handelTakeTestLSQ();

      const baseUrl = `${CONFIG_VARS.scoreViewreportUrl}/test/testinstructions?test_type=e34d1d14-6c33-48fd-900e-e8d3cb76da64`;
      const examId = examdetailes.exam_id;
      const eventId = examdetailes.event_id;
      const token = access_token.replace("Bearer ", "");
      const url = `${baseUrl}&exam_id=${examId}&event_id=${eventId}&token=${token}&is_from=genius&landing_source=${source}`;
      window.open(url, "_self", "noreferrer");
    } catch (error) {
      console.error("Error redirecting to test:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  const buttonLoading = isUpdating;

  return (
    <div className="AttemptCard">
      {currentExam && <img className="doto-illution" src={getImage(currentExam)} alt={currentExam} />}
      <div className={`top__card ${getClass(currentExam)}`}>
        <div className="exam-titleCont">
          <h3 className="examTitle">
            {ExamConfigHelper.getDisplayName(examdetailes.title)}{" "}
            {["semi-finals", "finals"].includes(examdetailes.level?.toLowerCase()) ? "" : examdetailes.level}
          </h3>
          <div className="examlivemob ">
            {buttonConfig.showLive && (
              <span className="staus-display">
                <img className="status-icon" src={live} alt="status" />
                Live
              </span>
            )}
          </div>
        </div>
        <div className="group-cont">
          <img src={group} alt="group" />
          <p className="group-des">+90.7k attempted from your city.</p>
        </div>
      </div>
      <div className="bottam__card">
        <div className="examliveweb">
          {buttonConfig.showLive && (
            <span className="staus-display">
              <img className="status-icon" src={live} alt="status" />
              Live
            </span>
          )}
        </div>
        <button onClick={redirectToEvent} className="attempt-btn" disabled={buttonLoading}>
          {buttonLoading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Updating...
            </>
          ) : (
            buttonConfig.text
          )}
        </button>
      </div>
    </div>
  );
};
